export const inputgroup = {
  addon: {
    background: "{form.field.background}",
    borderColor: "{form.field.border.color}",
    color: "{form.field.icon.color}",
    borderRadius: "{form.field.border.radius}",
    padding: "{padding.8}",
    minWidth: "{form.field.icon.size}",
  },
  css: (): string => `
    .p-inputgroup:has(.p-inputgroupaddon:first-child) .p-datepicker-input,
    .p-inputgroup:has(.p-inputgroupaddon:first-child) .p-inputtext,
    .p-inputgroup:has(.p-inputgroupaddon:first-child) .p-textarea {
      border-start-start-radius: 0;
      border-end-start-radius: 0;
    }

    .p-inputgroup:has(.p-inputgroupaddon:last-child) .p-datepicker-input,
    .p-inputgroup:has(.p-inputgroupaddon:last-child) .p-inputtext,
    .p-inputgroup:has(.p-inputgroupaddon:last-child) .p-textarea {
      border-start-end-radius: 0;
      border-end-end-radius: 0;
    }

    .p-inputgroup:has(.p-inputgroupaddon:first-child) .p-editor .p-editor-toolbar {
      border-start-start-radius: 0;
    }

    .p-inputgroup:has(.p-inputgroupaddon:first-child) .p-editor .p-editor-content {
      border-end-start-radius: 0;
    }

    .p-inputgroup:has(.p-inputgroupaddon:last-child) .p-editor .p-editor-toolbar {
      border-start-end-radius: 0;
    }

    .p-inputgroup:has(.p-inputgroupaddon:last-child) .p-editor .p-editor-content {
      border-end-end-radius: 0;
    }
  `,
};
